import React from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

export default function RichTextBlock({ data }) {
  return (
    <div className="text-white max-w-none prose prose-th:font-[optima-lt-pro] prose-headings:text-white md:prose-headings:text-xl lg:prose-headings:text-2xl prose-th:text-lg prose-td:font-[lato] prose-a:text-bhagwa prose-a:font-[lato] prose-strong:font-[optima-lt-pro] prose-strong:text-white prose-strong:font-bold prose-headings:font-[optima-lt-pro] prose-li:font-[lato] prose-li:marker:text-bhagwa prose-li:text-sm xl:prose-li:text-base prose-li:font-light  prose-headings:font-normal prose-h2:uppercase prose-headings:mb-2 prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg prose-h4:text-base prose-h5:text-base prose-h6:text-base prose-p:font-[lato] prose-p:text-sm prose-p:leading-6 xl:prose-p:text-base  prose-p:font-light">
      <Markdown rehypePlugins={[rehypeRaw, remarkGfm]}>{data}</Markdown>
    </div>
  );
}
